import Cookie from 'js-cookie';
import * as cons from './constants';

const defaultInitialArrayState = {
  data: [],
  dataFetched: false,
  isFetching: false,
  error: false,
};
const defaultInitialObjectState = {
  data: {},
  dataFetched: false,
  isFetching: false,
  error: false,
};

export const fetchingState = (state, action) => ({
  ...state,
  isFetching: true,
  type: action.type
});

export const successState = (state, action) => ({
  ...state,
  dataFetched: true,
  isFetching: false,
  error: false,
  timestamp: Date.now(),
  type: action.type,
  ...action
});

export const failureState = (state, action) => ({
  ...state,
  isFetching: false,
  error: true,
  timestamp: Date.now(),
  api: action.cons,
  type: action.type,
  ...action
});

export const simpleReducer = (cons, state, action) => {
  switch (action.type) {
    case cons.FETCHING: return fetchingState(state, action);
    case cons.SUCCESS: return successState(state, action);
    case cons.FAILURE: return failureState(state, action);
    case cons.CLEAR: return defaultInitialObjectState;
    default: return state;
  }
};

export const multiReducer = (cons_arr, state, action) => {
  for (const i in cons_arr) {
    const cons = cons_arr[i];
    switch (action.type) {
      case cons.FETCHING: return fetchingState(state, action);
      case cons.SUCCESS: return successState(state, action);
      case cons.FAILURE: return failureState(state, action);
      case cons.CLEAR: return defaultInitialObjectState;
    }
  }
  return state;
};

const authForgetPasswordInfo = (state = defaultInitialObjectState, action) => simpleReducer(cons.AUTH_FORGET_PASSWORD, state, action);

const authLoginInfoInitialState = Cookie.get('authLoginInfo') ? {
  data: JSON.parse(Cookie.get('authLoginInfo')),
  dataFetched: true,
  isFetching: false,
  error: false,
  timestamp: Date.now(),
  type: cons.AUTH_LOGIN.SUCCESS,
} : defaultInitialArrayState;

const authLoginInfo = (state = authLoginInfoInitialState, action) => {
  switch (action.type) {
    case cons.AUTH_LOGIN.FETCHING:
      Cookie.remove('authLoginInfo');
      return fetchingState(state, action);
    case cons.AUTH_LOGIN.SUCCESS:
      Cookie.set('authLoginInfo', JSON.stringify(action.data));
      return successState(state, action);
    case cons.AUTH_LOGIN.FAILURE:
      return failureState(state, action);
    default:
      return state;
  }
};

const authRegisterInfo = (state = defaultInitialObjectState, action) => simpleReducer(cons.AUTH_REGISTER, state, action);
const authResendVerificationTokenInfo = (state = defaultInitialObjectState, action) => simpleReducer(cons.AUTH_RESEND_VERIFICATION_TOKEN, state, action);
const authResetPasswordInfo = (state = defaultInitialObjectState, action) => simpleReducer(cons.AUTH_RESET_PASSWORD, state, action);
const authVerifyInfo = (state = defaultInitialObjectState, action) => simpleReducer(cons.AUTH_VERIFY, state, action);
const authVerifyForgetPasswordTokenInfo = (state = defaultInitialObjectState, action) => simpleReducer(cons.AUTH_VERIFY_FORGET_PASSWORD_TOKEN, state, action);

/* Options */
const optionsFinancialYearInfo = (state = defaultInitialArrayState, action) => multiReducer([cons.READ_OPTIONS_FINANCIAL_YEAR, cons.READ_OPTIONS_PUBLIC_FINANCIAL_YEAR], state, action);
const optionsFundInfo = (state = defaultInitialArrayState, action) => multiReducer([cons.READ_OPTIONS_FUND, cons.READ_OPTIONS_PUBLIC_FUND], state, action);
const optionsGivingInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_OPTIONS_GIVING, state, action);
const optionsReceiptInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_OPTIONS_RECEIPT, state, action);
const optionsPaymentMethodInfo = (state = defaultInitialArrayState, action) => multiReducer([cons.READ_OPTIONS_PAYMENT_METHOD, cons.READ_OPTIONS_PUBLIC_PAYMENT_METHOD], state, action);
const optionsServiceInfo = (state = defaultInitialArrayState, action) => multiReducer([cons.READ_OPTIONS_SERVICE, cons.READ_OPTIONS_PUBLIC_SERVICE], state, action);
const optionsAuthRegisterInfo = (state = defaultInitialObjectState, action) => simpleReducer(cons.READ_OPTIONS_AUTH_REGISTER, state, action);
const optionsPublicFinancialYearInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_OPTIONS_PUBLIC_FINANCIAL_YEAR, state, action);
const optionsPublicFundInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_OPTIONS_PUBLIC_FUND, state, action);
const optionsPublicGivingInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_OPTIONS_PUBLIC_GIVING, state, action);
const optionsPublicPaymentMethodInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_OPTIONS_PUBLIC_PAYMENT_METHOD, state, action);
const optionsPublicServiceInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_OPTIONS_PUBLIC_SERVICE, state, action);

/* Public */
const publicGivingInfo = (state = defaultInitialObjectState, action) => multiReducer([cons.CREATE_PUBLIC_GIVING, cons.READ_PUBLIC_GIVING, cons.UPDATE_PUBLIC_GIVING, cons.DELETE_PUBLIC_GIVING], state, action);

/* Giver */
const currentInfo = (state = defaultInitialObjectState, action) => multiReducer([cons.READ_CURRENT, cons.UPDATE_CURRENT], state, action);

const givingsStatisticsInfo = (state = defaultInitialObjectState, action) => simpleReducer(cons.READ_GIVINGS_STATISTICS, state, action);
const givingsInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_GIVINGS, state, action);
const givingInfo = (state = defaultInitialObjectState, action) => multiReducer([cons.READ_GIVING, cons.CREATE_GIVING], state, action);
const recurringGivingInfo = (state = defaultInitialObjectState, action) => simpleReducer(cons.UPDATE_RECURRING_GIVING, state, action);

const productsInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_PRODUCTS, state, action);
const productInfo = (state = defaultInitialObjectState, action) => multiReducer([cons.READ_PRODUCT, cons.CREATE_PRODUCT, cons.UPDATE_PRODUCT, cons.DELETE_PRODUCT], state, action);

const receiptsInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_RECEIPTS, state, action);
const receiptInfo = (state = defaultInitialObjectState, action) => multiReducer([cons.READ_RECEIPT, cons.CREATE_RECEIPT, cons.UPDATE_RECEIPT, cons.DELETE_RECEIPT], state, action);

const subscriptionsInfo = (state = defaultInitialArrayState, action) => simpleReducer(cons.READ_SUBSCRIPTIONS, state, action);
const subscriptionInfo = (state = defaultInitialObjectState, action) => multiReducer([cons.READ_SUBSCRIPTION, cons.CREATE_SUBSCRIPTION, cons.UPDATE_SUBSCRIPTION, cons.DELETE_SUBSCRIPTION, cons.CANCEL_SUBSCRIPTION], state, action);

export default {
  authForgetPasswordInfo,
  authLoginInfo,
  authRegisterInfo,
  authResendVerificationTokenInfo,
  authResetPasswordInfo,
  authVerifyInfo,
  authVerifyForgetPasswordTokenInfo,
  optionsFinancialYearInfo,
  optionsGivingInfo,
  optionsReceiptInfo,
  optionsFundInfo,
  optionsPaymentMethodInfo,
  optionsServiceInfo,
  optionsAuthRegisterInfo,
  optionsPublicFinancialYearInfo,
  optionsPublicGivingInfo,
  optionsPublicFundInfo,
  optionsPublicPaymentMethodInfo,
  optionsPublicServiceInfo,
  publicGivingInfo,
  currentInfo,
  givingsStatisticsInfo,
  givingInfo,
  givingsInfo,
  recurringGivingInfo,
  productInfo,
  productsInfo,
  receiptInfo,
  receiptsInfo,
  subscriptionInfo,
  subscriptionsInfo,
};
